export class DateSerializer {
  serialize(arg) {
    return `${arg.getFullYear()}-${arg.getMonth() + 1}-${arg.getDate()}`;
  }

  deserialize(arg) {
    const [year, month, date] = arg.split('-');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(date));
  }

}